import { useEffect, useRef } from "react";

// Jobber Work Request embed configuration. These IDs are public — they're
// included verbatim in the snippet provided by Jobber.
const CLIENTHUB_ID = "0b0022e2-704c-458d-8b4b-f6299763c609-4860518";
const FORM_URL =
  "https://clienthub.getjobber.com/client_hubs/0b0022e2-704c-458d-8b4b-f6299763c609/public/work_request/embedded_work_request_form?form_id=4860518";
const STYLESHEET =
  "https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css";
const SCRIPT_SRC =
  "https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js";
const SCRIPT_ID = "jobber-work-request-embed";

/**
 * Renders the Jobber Work Request form by injecting Jobber's embed script.
 * The script reads its own `clienthub_id` and `form_url` attributes,
 * locates the matching mount div, and injects the form.
 *
 * Uses a useRef guard so React StrictMode's double-invocation in dev does
 * NOT cause the script to inject twice (which would render two stacked
 * error messages on failure).
 */
export default function JobberWorkRequestForm() {
  const didInit = useRef(false);

  useEffect(() => {
    // StrictMode safety: only initialize once per real mount
    if (didInit.current) return;
    didInit.current = true;

    // Inject stylesheet once globally
    if (!document.querySelector(`link[href="${STYLESHEET}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = STYLESHEET;
      link.media = "screen";
      document.head.appendChild(link);
    }

    // Clear any prior instance (handles SPA navigation back to this page)
    document.getElementById(SCRIPT_ID)?.remove();
    const mount = document.getElementById(CLIENTHUB_ID);
    if (mount) mount.innerHTML = "";

    // Add a fresh script tag — Jobber's snippet bootstraps on script load
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.setAttribute("clienthub_id", CLIENTHUB_ID);
    script.setAttribute("form_url", FORM_URL);
    document.body.appendChild(script);
  }, []);

  return (
    <div
      id={CLIENTHUB_ID}
      data-testid="jobber-work-request-form"
      className="bg-white border border-slate-200 rounded-lg p-4 sm:p-6 shadow-sm min-h-[480px]"
    />
  );
}
